export enum PersistentStore {
    auth = 'salesmaster.auth',
    preferences = 'salesmaster.preferences',
}

export function setPersistentStoreValue(key: PersistentStore, value: unknown): void {
    sessionStorage.setItem(key, JSON.stringify(value));
}

export function getPersistentStoreValue(key: PersistentStore, defaultValue: unknown = undefined): unknown {
    const json: string | null = sessionStorage.getItem(key);
    if (json === null || json === undefined) {
        return defaultValue;
    }
    return JSON.parse(json);
}

export function deletePersistentStoreValue(key: PersistentStore): void {
    sessionStorage.removeItem(key);
}
